import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './ServicesCardsPrivateCloud.css';
import { services } from './ServicesDataPrivateCloud';
import { TimelineFormation } from '../../ui/timeline-formation';
import FeatureDetailModal from './FeatureDetailModal';
import { Feature } from './types';
import './timeline-custom.css';

interface DetailModalState {
  isOpen: boolean;
  title: string;
  content: string;
}

const TimelineFormationEntra: React.FC = () => {
  const { t } = useTranslation();
  const [detailModal, setDetailModal] = useState<DetailModalState>({
    isOpen: false,
    title: '',
    content: '',
  });

  const openDetailModal = (feature: Feature) => {
    if (feature.detailContent) {
      setDetailModal({
        isOpen: true,
        title: feature.text,
        content: feature.detailContent,
      });
    }
  };

  const closeDetailModal = () => {
    setDetailModal((prev) => ({ ...prev, isOpen: false }));
  };

  const timelineItems = services.map(service => ({
    date: "",
    title: service.titleKey ? t(service.titleKey, service.title) : service.title,
    description: service.descriptionKey ? t(service.descriptionKey, service.description) : service.description,
    icon: service.icon,
    features: service.features
      .filter(f => f.text !== '')
      .map(feature => ({
        ...feature,
        text: feature.textKey ? t(feature.textKey, feature.text) : feature.text,
        detailContent: feature.detailContentKey ? t(feature.detailContentKey, feature.detailContent) : feature.detailContent,
        renderDetail: feature.detailContent ? (
          <div className="">

          </div>
        ) : null
      }))
  }));

  useEffect(() => {
    const timelineCardTitles = document.querySelectorAll('.slider-cards h3.blue-h2-blue-bg');
    
    timelineCardTitles.forEach(element => {
      if (element instanceof HTMLElement) {
        element.style.paddingLeft = '30px';
      }
    });
    
  }, []);

  return (
    <div className="tw-container entra-timeline tw-mx-auto tw-px-4 tw-pb-16 tw-bg-transparent">
      <div className="centered-title-dark-bg">
        <h2>{t('formationEntra.timeline.title', 'Programme de la formation')}</h2>
      </div>
      <TimelineFormation items={timelineItems} showModule={true} />
      
    </div>
  );
};

export default TimelineFormationEntra;